export const checkToken = (uuid, sso_token) => {
	let formData = new FormData();
	formData.append('uuid', uuid);
	formData.append('sso_token', sso_token);
	return formData;
};
